"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_bi_video_card_name_1 = tslib_1.__importDefault(require("../bi-selectors/get-bi-video-card-name"));
var lodash_1 = require("lodash");
function createVideoCardsBiLogger(logBi) {
    return {
        logCardClick: function (_a) {
            var card = _a.card, biOrigin = _a.biOrigin;
            return logBi('widget.videoCards.card.click', {
                cardName: (0, get_bi_video_card_name_1.default)(card),
                origin: biOrigin,
                socialNetwork: (0, lodash_1.get)(card, 'network', null),
            });
        },
        logCardCloseButtonClick: function (_a) {
            var card = _a.card;
            return logBi('widget.videoCards.card.close.click', {
                cardName: (0, get_bi_video_card_name_1.default)(card),
            });
        },
        logAllCardsButtonClick: function () {
            return logBi('widget.videoCards.allCards.open.click');
        },
        logAllCardsCloseButtonClick: function () {
            return logBi('widget.videoCards.allCards.close.click');
        },
    };
}
exports.default = createVideoCardsBiLogger;
//# sourceMappingURL=create-video-cards-bi-logger.js.map